import { parseApiDateTime } from './parseApiDateTime'

export const getApiDateTimeMillis = (value?: string | null) => {
  const dateTime = parseApiDateTime(value)
  if (!dateTime) return null
  return dateTime.toMillis()
}
